export {}

const insuranceEventForms = document.querySelectorAll<HTMLElement>('.f-return-car');

insuranceEventForms.forEach(form => {
  const carModelInput = form.querySelector<HTMLElement>('.f-return-car__car-model')
  const carBrandSelect = form.querySelector<HTMLSelectElement>('.f-return-car__car-brand select')

  const disableCarModel = (disable : boolean) => {
    if (disable) carModelInput?.classList.add('--disabled')
    else carModelInput?.classList.remove('--disabled')
  }

  carBrandSelect?.addEventListener('change', () => {
    disableCarModel(!carBrandSelect?.value)
  })

  disableCarModel(!carBrandSelect?.value)
})
